<template>
  <footer class="footer">
    <div class="footer_container">
      <img width="150" src="../assets/image/dentrion_logo.svg" alt="Dentrion Logo" />

      <!-- Social Icons -->
      <div class="social_icons">
        <a href="https://dentrion.co.kr/" target="_blank">
          <img src="../assets/icon/web.svg" alt="Web" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61559681795626" target="_blank">
          <img src="../assets/icon/Facebook.svg" alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/dentrion_official/" target="_blank">
          <img src="../assets/icon/Instagram.svg" alt="Instagram" />
        </a>
        <a href="https://www.youtube.com/@dentrion_official" target="_blank">
          <img src="../assets/icon/YouTube.svg" alt="YouTube" />
        </a>
        <a href="https://maps.app.goo.gl/JZywGwHqxgdkyLsB9" target="_blank">
          <img src="../assets/icon/map.svg" alt="Map" />
        </a>
      </div>

      <div class="toggle_title" @click="isOpen = !isOpen">
        <p>Business Information</p>
        <div class="toggle_icon" :class="{ 'rotate-180': isOpen }">
          <img width="28" src="../assets/icon/down_arrow_white.png" alt="Toggle" />
        </div>
      </div>

      <!-- Business Info -->
      <transition name="slide">
        <div v-if="isOpen" class="business_info">
          <p class="business_info_item">
            <span class="label">Business Name</span> DENTRION
          </p>
          <p class="business_info_item"><span class="label">CEO</span> ILDO JEONG</p>
          <p class="business_info_item">
            <span class="label">Business License</span> 604-85-60729
          </p>
          <p class="business_info_item">
            <span class="label">Address</span> 703~707, Building A, Incheon Technovalley U1 Center,
             236, Jubuto-ro, Bupyeong-gu, Incheon, Republic of Korea
          </p>
          <p class="business_info_item">
            <span class="label">TEL</span> 032-545-2804 / 032-541-5703
          </p>
          <p class="business_info_item">
            <span class="label">E-mail</span> contact@dentrion.co.kr
          </p>
        </div>
      </transition>

      <!-- Privacy Policy -->
      <div class="privacy_policy">
        <a
          href="https://kr.object.ncloudstorage.com/dentrion-resource/policy/dentrion_privacy_policy_global_en.html"
          target="_blank"
        >
          Privacy Policy
        </a>
      </div>

      <!-- Copyright -->
      <div class="copyright">ⓒ 2026. DENTRION All rights reserved.</div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>
<style scoped>
/* Footer 스타일 */
.footer {
  background-color: black;
  color: white;
  width: 100%;
  padding: 60px 37px 80px 32px;
  box-sizing: border-box;
}

.footer_container {
  max-width: 1200px;
  margin: 0 auto; /* Center container content if max-width is used, but content inside is left aligned */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Left align */
  text-align: left;
}

/* Social Icons */
.social_icons {
  display: flex;
  gap: 20px;
  margin: 24px 0 27px 0;
}

.social_icons a {
  display: flex; 
  align-items: center;
  transition: opacity 0.3s;
}

.social_icons a:hover {
  opacity: 0.8;
}

.social_icons img {
  height: 24px; /* Adjust size as needed based on SVG natural size */
  width: auto;
}

/* Business Info Toggle */
.toggle_title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
}

.toggle_icon {
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
}

.toggle_icon.rotate-180 {
  transform: rotate(180deg);
}

/* Business Info Content */
.business_info {
  color: #fff;
  font-size: 13px;
  margin-bottom: 30px;
  overflow: hidden; 
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-weight: 500;
  line-height: 128%;
  letter-spacing: -0.65px;
}

.business_info_item {
  margin-bottom: 6px;
}

.label {
  font-weight: 700; 
  color: #fff;  
  margin-right: 6px;
}

.business_info_item .label {
  color: #7C7C7C;
}

/* Privacy Policy */
.privacy_policy {
  margin-bottom: 8px;
}

.privacy_policy a {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 4px;
}

/* Copyright */
.copyright {
  font-size: 12px;
  color: #fff;
  font-weight: 400;
}

/* Slide Transition */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
  max-height: 500px; /* Adjust based on content height */
  opacity: 1;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0; /* Collapse margin as well */
}
</style>
